<template>
<div id="locker">
    <div class="locker-bg locker-wrap">
        <div class="row">
            <div res_info="0" :id="item.locker_name" v-for="(item , index) in locker_list" :key="index" v-bind:style="{ left:item.position_x-min_pos_x+'px', top:item.position_y-min_pos_y+'px', background:item.code_value, color:item.code_value_text, width:item.width_size+'px', height:item.height_size+'px', 'line-height':item.line_height+'px', 'font-size':item.font_size+'px'}" class="locker-column" @click="set_seatdata(item)">
                {{item.locker_name}}
            </div>
        </div>
    </div>

</div>
</template>

<script>
// 사용자 정의 모듈.
import * as config from '../../javascript/config';
export default {
    name: 'locker',
    data: function () {
        return {

            //new logic
            locker_list: [],
            locker_all_list: [],

            //my locker list
            my_locker_list: [],

            first_loading_locker_count:0,
            min_pos_x : 0,
            min_pos_y : 0
        }
    },
    props: [
        'hot_table',
        'locker_group_id',
        'from_pop'

    ],
    methods: {
        refresh_from_main(time, callback){
            this.get_locker_data();
            setTimeout(function() {
                callback(false);
            }, time);
        },
        set_seatdata(item) {
            this.$emit("select_locker_data", item);
        },
        send_data(item) {
            this.go_payment_locker(item);
        },

        go_payment_locker(item) {
            // 내 사물함 팝업이 떠잇는 상태에서의 사물함 클릭이라면 set_move_locker() 함수 호출
            if (this.from_pop) {
                this.set_move_locker(item);
                return;
            }
            // 로그인 상태여부 체크
            var router = this.$router;
            if (!this.$store.state.login_chk) {
                this.$store.commit('set_Last_URL', '');
                this.$store.commit('change_main_tab_chk', {
                    value: 1
                });
                // router.push('/login');
            } else {
                // 내가 사용중인 사물함 이 있다면
                if (this.my_locker_list.length > 0) {
                    // store  배열에 데이터 셋팅
                    this.$store.commit('set_select_locker', {
                        locker: item
                    });
                    this.$store.commit('set_my_locker_data', {
                        locker_id: this.my_locker_list[0].locker_id,
                        locker_use_id: this.my_locker_list[0].locker_use_id
                    });
                    // 내가 사용중인 사물함들 중에 현재 클릭한 사물함의 locker id 가 일치하면 내사물함을 클릭한것이므로,
                    for (let i = 0; i < this.my_locker_list.length; i++) {
                        if (item.locker_id == this.my_locker_list[i].locker_id) {
                            // 그후 내사물함 으로 무얼할지 진행하는 popup 호출
                            const alert_param = {
                                code: this.$store.getters['get_popup_code'].POPUP_USE_LOCKER_TYPE,
                            };
                            this.$store.commit('set_popup_type', alert_param);
                            return;
                        }
                    }
                    // 사물함 이동 주석처리
                    // if(item.locker_status_code == 'LOCKER_AVAILABLE'){
                    //     var sel_locker_id = item.locker_id;
                    //     var sel_locker_name = item.locker_name;
                    //     var my_locker_id = this.my_locker_list[0].locker_id;
                    //     var my_locker_use_id = this.my_locker_list[0].locker_use_id;
                    //     this.$store.commit('set_main_page_update_locker', {
                    //         'sel_locker_id': sel_locker_id,
                    //         'sel_locker_name' : sel_locker_name,
                    //         'my_locker_id' : my_locker_id,
                    //         'my_locker_use_id' : my_locker_use_id
                    //     });
                    //     const alert_param = {
                    //         code: this.$store.getters['get_popup_code'].POPUP_LOCKER_MOVE_CHECK,
                    //     };
                    //     this.$store.commit('set_popup_type', alert_param);
                    //     return false;
                    // }
                    // ----까지
                     
                    // 매장옵션에서 사물함 추가구매 불가 설정시 
                    // 내가 사용중인 사물함이 있지만 , 클릭한 사물함이 내 사물함이 아닐경우 현재 이미 사용중인 사물함이 있으므로 더이상의 사물함 즉시적용 구매 프로세스 호출 방지
                    const store_info = this.$store.getters['getStoreInfo'];
                    const locker_plus = store_info.locker_plus || "0"; 
                    if(locker_plus == "0"){
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `사용중인 사물함이있습니다.`,
                            router: '',
                        };
                        this.$store.commit('set_popup_type', alert_param);
                        return;
                    }
                }
                // 현재 내가 사용하고 있는 사물함이 없는 상태에서 다른사람이 사용하고 있는 사물함 을 클릭했을시 이미 사용하고 있다는 메세지를 보여주는 popup 호출
                if (item.locker_status_code != "LOCKER_AVAILABLE") {
                    this.$store.commit('set_popup_type', {
                        code: this.$store.getters['get_popup_code'].POPUP_POPUP_ALREADY_USE_LOCKER,
                        message: null,
                        router: null
                    });

                    return;
                }

                this.$store.commit('set_select_locker', {
                    locker: item
                });
                router.push('/payment-locker');
            }
        },
        set_move_locker(item) {
            // 사물함 이동 popup 프로세스가 진행중인 상태라면 , 현재 클릭된 사물함 의 데이터를 비교한다.
            for (let i = 0; i < this.my_locker_list.length; i++) {
                // 선택한 사물함 이 현재내가 사용중인 사물함 이라면 이동할수없다는 popup 호출
                if (item.locker_id == this.my_locker_list[i].locker_id) {
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `해당 사물함으로 이동이 불가능합니다. `,
                        router: '',
                    };
                    this.$store.commit('set_popup_type', alert_param);
                    return;
                }
            }
            // 선택한 사물함 이 내가현재 사용하고있는 사물함 이 아니고 , 사용가능 상태라면
            if (item.locker_status_code == 'LOCKER_AVAILABLE') {
                // popup 의 select_locker_data 이름으로 등록되어있는 popup 쪽 함수를 호출하면서 방금 클릭한 사물함 의 정보를 보낸다(item)
                this.$emit("select_locker_data", item);
            }
        },
        get_locker_data() {
            const type = config.REQ_LOCKER_GET_LIST;
            const data = {};
            this.$store.dispatch(type.action_name, {
                type: type,
                data: data
            }).then(response => {
                // 데이터를 담아낸뒤
                this.locker_all_list = response.data;
                for (let i = 0; i < this.locker_all_list.length; i++) {
                    for (let z = 0; z < this.locker_all_list[i].lockers.length; z++) {
                        if (this.locker_all_list[i].lockers[z].code_value != null && this.locker_all_list[i].lockers[z].code_value != "") {
                            if (this.locker_all_list[i].lockers[z].code_value.indexOf(",") != -1) {
                                var color = this.locker_all_list[i].lockers[z].code_value.split(',');
                                this.locker_all_list[i].lockers[z].code_value = color[0];
                                this.locker_all_list[i].lockers[z].code_value_text = color[1];
                            }
                        }
                    }
                }
                for (let i = 0; i < this.locker_all_list.length; i++) {
                    if (this.locker_group_id == this.locker_all_list[i].locker_group_id) {
                        this.locker_list = this.locker_all_list[i].lockers;
                        break;
                    } else {
                        this.locker_list = [];
                    }
                }

                var pos_x = new Array();
                var pos_y = new Array();
                this.locker_list.forEach(el => {
                    pos_x.push(el.position_x);
                    pos_y.push(el.position_y);
                });
                var min_pos_x = Math.min.apply(null, pos_x);
                var min_pos_y = Math.min.apply(null, pos_y);

                this.min_pos_x = min_pos_x
                this.min_pos_y = min_pos_y

            }).then(() => {
                this.reset_status_locker();
            }).catch(function (error) {
                console.log('error=============>!', error);
            });
        },
        reset_status_locker() {
            //만약 로그인이 되어있다면 ,
            if (this.$store.state.login_chk) {
                // 현재 사용중인 나의 라커 정보를 가져온다.
                const type = config.REQ_LOCKER_USE_GET;
                const data = {};
                this.$store.dispatch(type.action_name, {
                    type: type,
                    data: data
                }).then(response => {
                    // 데이터를 담아낸뒤
                    this.my_locker_list = response.data;

                    //현재 이 프로세스가 내 사물함을 클릭했을시 나오는 popup 위에서 진행되고있는 중이라면,
                    if (this.from_pop) {
                        // this.rest_locker_forMove() 함수를 호출한다.
                        this.rest_locker_forMove();
                    } else {
                        var temp_my_seat_color = this.$store.getters['get_my_color']['my_locker_color'];
                        if (typeof temp_my_seat_color == 'undefined' || temp_my_seat_color == '') {
                            temp_my_seat_color = 'red';
                        } else {
                            if (temp_my_seat_color.indexOf(",") != -1) {
                                var color = temp_my_seat_color.split(',');
                                temp_my_seat_color = color[0];
                            }
                        }
                        //그게 아니라면 locker_list 안에 나의 사물함 정보를 비교해 나의 사물함 인경우 사물함 셀의 background 색을 red로 변경한다.
                        if (this.my_locker_list.length > 0) {
                            for (let i = 0; i < this.locker_list.length; i++) {
                                for (let z = 0; z < this.my_locker_list.length; z++) {
                                    if (this.locker_list[i].locker_id == this.my_locker_list[z].locker_id) {
                                        this.locker_list[i].code_value = temp_my_seat_color;
                                        // this.$set(this.seat_list, i, this.locker_list[i]);
                                    }
                                }
                            }
                        }
                    }
                }).catch(function (error) {
                    console.log('error=============>!!', error);
                });
                ++this.first_loading_locker_count;

                if (this.first_loading_locker_count == 1) {
                    this.$emit("first_loading_locker");
                }

            }
        },
    },
    mounted() {
        this.$nextTick(function () {
            this.$store.commit('set_page_header_init', {
                style: 'block'
            });
            this.get_locker_data();
        });

    },
    computed: {
        get_locker_move_flag() {
            return this.$store.getters.get_locker_move_flag;
        }

    },
    watch: {
        locker_group_id() {
            this.get_locker_data();
        },
        get_locker_move_flag(val, OldVal) {
            this.get_locker_data();
        }
    },
    beforeCreate() {
        // EventBus.$on("eve_locker", ($event) => {
        //     this.my_locker = localStorage.getItem('set_locker');
        //     this.data_reload();
        // });
    }
}
</script>

<style>
</style>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/components/locker.vue